// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__DdFUz","isSelected":"Button_isSelected__meoI5"};